const addScheme = (url: string, scheme?: string) => {
	if (!/^(?:f|ht)tps?:\/\//.test(url)) {
		return `${scheme || 'http'}://${url}`
	}
	return url
}

export default addScheme
